import { Coordinate } from "../models"
import { fineToRoughCoordinates, incrementViaDirection, radiansToCardinalDirection } from "../util"

export const facingPlacementTarget = (location: Coordinate, angle: number): Coordinate => {
    const target = fineToRoughCoordinates(location)
    incrementViaDirection(target, radiansToCardinalDirection(angle), 1)
    return target
}

export const clampPlacementTarget = (origin: Coordinate, target: Coordinate, range: number): Coordinate => ({
    x: Math.max(origin.x - range, Math.min(origin.x + range, target.x)),
    y: Math.max(origin.y - range, Math.min(origin.y + range, target.y)),
})

export const placementTargetInRange = (origin: Coordinate, target: Coordinate, range: number): boolean =>
    !!target && Number.isInteger(target.x) && Number.isInteger(target.y) &&
    Math.abs(target.x - origin.x) <= range && Math.abs(target.y - origin.y) <= range
